import { ButtonPrimary } from 'components/Button/Button'
import TypographyPrimary from 'components/Typography/Primary'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const AdminHome = () => {
  const navigate = useNavigate()

  return (
    <StyledRoot>
      <TypographyPrimary size='x-large' value='Welcome to Your Dashboard' bold />
      <TypographyPrimary
        size='medium'
        value='As an admin, you are responsible for activating user accounts.'
      />

      <StyledButtonWrapper>
        <ButtonPrimary onClick={() => navigate('/admin')}>Get Started</ButtonPrimary>
      </StyledButtonWrapper>
    </StyledRoot>
  )
}

export default AdminHome

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding-bottom: 200px;

  height: 100%;
  width: 100%;
`
const StyledButtonWrapper = styled.div`
  margin-top: 20px;
`
